<script>
import { mapActions, mapState } from 'vuex';
import validatorMixin from '../../mixins/validatorMixin';

export default {
  name: 'FerryCabinAdd',
  mixins: [
    validatorMixin,
  ],
  props: {
    shown: {
      type: Boolean,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      validForm: true,
      cabin: null,
    };
  },
  computed: {
    ...mapState({
      saveError: state => state.transportation.cabins.saveError,
      saveLoading: state => state.transportation.cabins.saveLoading,
      personCategories: state => state.transportation.personCategories.items,
      personCategoriesItemsLoading: state => state.transportation.personCategories.itemsLoading,
      supplier: state => state.transportation.suppliers.supplier,
    }),
  },
  methods: {
    ...mapActions({
      getPersonCategoriesBySupplier: 'transportation/getPersonCategoriesBySupplier',
      addCabinByRoute: 'transportation/addCabinByRoute',
    }),
    saveCabin() {
      if (this.validForm) {
        const cabinToSave = {
          ...this.cabin,
          ferryPersonCategoryId: this.cabin.personCategoryId,
        };
        this.addCabinByRoute(cabinToSave)
          .then((res) => {
            if (res) {
              this.$emit('close', true);
            }
          });
      }
    },
    resetCabin() {
      this.cabin = {
        name: null,
        webName: null,
        minPersons: 1,
        maxPersons: null,
        externalRef: null,
        ferryPersonCategoryId: null,
        active: true,
      };
    },
  },
  watch: {
    shown() {
      if (this.shown) {
        this.$refs.addCabinForm.resetValidation();
        this.resetCabin();
        this.getPersonCategoriesBySupplier();
      }
    },
  },
  created() {
    this.resetCabin();
  },
};
</script>

<template>
  <v-card>
    <v-form v-model="validForm" @submit.prevent="saveCabin" ref="addCabinForm">
      <v-card-title>
        <v-card-title>
          <v-layout wrap>
            <h2>Add Cabin</h2>
            <v-flex xs12>
              Please note that the text will be automatically created for all domains and translated using DeepL
            </v-flex>
          </v-layout>
        </v-card-title>
      </v-card-title>

      <v-card-text class="py-0 mb-3 edit-item-status">
        <v-progress-linear
          v-if="saveLoading"
          :active="saveLoading"
          :height="4"
          class="my-0"
          indeterminate
        />
        <v-alert
          v-if="!saveLoading"
          :value="!!saveError"
          class="my-0 py-2"
          transition="slide-y-transition"
          outline
        >
          The cabin could not be saved - please reload the page and try again
        </v-alert>
      </v-card-text>

      <v-card-text class="py-0">
        <v-container grid-list-md pt-1>
          <v-layout row>
            <v-flex xs12>
              <v-text-field
                v-model="cabin.name"
                :rules="[rules.required]"
                :disabled="saveLoading"
                label="Name"
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12>
              <v-text-field
                v-model="cabin.webName"
                :rules="[rules.required]"
                :disabled="saveLoading"
                label="Name displayed on the website"
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12>
              <v-text-field
                v-model="cabin.minPersons"
                :disabled="saveLoading"
                type="number"
                label="Min persons"
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12>
              <v-text-field
                v-model="cabin.maxPersons"
                :rules="[rules.required]"
                :disabled="saveLoading"
                type="number"
                label="Max persons"
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12>
              <v-text-field
                v-model="cabin.externalRef"
                :rules="[rules.required]"
                :disabled="saveLoading"
                hint="External ref is used to identify the cabin against suppliers system"
                label="External reference"
              />
            </v-flex>
          </v-layout>

          <v-layout v-if="type === 'train'" row>
            <v-flex xs12>
              <v-select
                v-model="cabin.personCategoryId"
                :items="personCategories"
                :loading="personCategoriesItemsLoading"
                label="Person category"
                item-text="name"
                item-value="id"
                hide-details
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12>
              <v-checkbox
                v-model="cabin.active"
                :disabled="saveLoading"
                label="Active"
                class="mt-0"
                hide-details
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-btn
          @click="$emit('close')"
          color="red darken-1"
          flat
        >
          Cancel
        </v-btn>
        <v-spacer/>
        <v-tooltip top>
          <template slot="activator" slot-scope="{ on }">
            <div v-on="on">
              <v-btn
                :disabled="!validForm || saveLoading"
                color="blue darken-1"
                type="submit"
                flat
              >
                Save
              </v-btn>
            </div>
          </template>
        </v-tooltip>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<style lang="scss">
  .edit-item-status {
    min-height: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/transportation/TransportationCabinAdd.vue